enum ItemClass {
  Consumable = 0,
  Container = 1,
  Weapon = 2,
  Armor = 4,
  Reagent = 5,
  Projectile = 6,
  TradeGoods = 7,
  Recipe = 9,
  Quiver = 11,
  Quest = 12,
  Key = 13,
  Miscellaneous = 15,
  WowToken = 18
}

export default ItemClass
